var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncentiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6711 23.8359V71.5049M59.5884 37.7394C59.5884 32.2575 54.2534 27.8084 47.6711 27.8084C41.0889 27.8084 35.7539 32.2575 35.7539 37.7394C35.7539 43.2213 41.0889 47.6704 47.6711 47.6704C54.2534 47.6704 59.5884 52.1195 59.5884 57.6015C59.5884 63.0834 54.2534 67.5325 47.6711 67.5325C41.0889 67.5325 35.7539 63.0834 35.7539 57.6015",
    stroke: "#048041",
    strokeWidth: 5.08469,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8074 13.2604C33.8436 9.7683 40.6959 7.93461 47.6694 7.94536C69.6091 7.94536 87.3936 25.7299 87.3936 47.6695C87.3936 69.6091 69.6091 87.3936 47.6694 87.3936C25.7298 87.3936 7.94531 69.6091 7.94531 47.6695C7.94531 40.4357 9.87988 33.6469 13.2604 27.8074",
    stroke: "#048041",
    strokeWidth: 5.08469,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentiveIcon);
export default __webpack_public_path__ + "static/media/IncentiveIcon.8af1a851bd4be1940748c0b4fc053f35.svg";
export { ForwardRef as ReactComponent };